import IMask from 'imask';

const mask = (element, settings, options) => IMask(element, { ...settings, ...options });

const numberSettings = {
  mask: Number,
  scale: 0, // digits after point, 0 for integers
  signed: false, // disallow negative
  thousandsSeparator: ' ',
};
const numberMask = (element, options) => mask(element, numberSettings, options);

const siretSettings = { mask: '000 000 000 00000' };
const siretMask = (element, options) => mask(element, siretSettings, options);

const oriasSettings = { mask: '0000 0000' };
const oriasMask = (element, options) => mask(element, oriasSettings, options);

const cciNumberSettings = { mask: '*** **** **** *** *** *** *** *** ***' };
const cciNumberMask = (element, options) => mask(element, cciNumberSettings, options);

const ibanNumberSettings = { mask: '**** **** **** **** **** **** ****' };
const ibanNumberMask = (element, options) => mask(element, ibanNumberSettings, options);

const dateMask = (element) => IMask(element, {
  mask: Date, // enable date mask

  // other options are optional
  pattern: 'd{/}`m{/}`Y',
  // you can provide your own blocks definitions, default blocks for date mask are:
  blocks: {
    d: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2,
    },
    m: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2,
    },
    Y: {
      mask: IMask.MaskedRange,
      from: 1900,
      to: 2020,
    },
  },
  // define date -> str convertion
  format(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();

    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;
    return [day, month, year].join('/');
  },
  // define str -> date convertion
  parse(str) {
    const yearMonthDay = str.split('/').map(Number);
    const date = new Date(yearMonthDay[2], yearMonthDay[1] - 1, yearMonthDay[0]);
    return date;
  },

  // optional interval options
  min: new Date(1900, 0, 1), // defaults to `1900-01-01`
  max: new Date(2020, 0, 1), // defaults to `9999-01-01`

  // also Pattern options can be set
  lazy: false,

  // and other common options
  overwrite: true, // defaults to `false`
});

const birthDateMask = (element) => dateMask(element);

const echeanceMask = (element) => IMask(element, {
  mask: Date, // enable date mask

  // other options are optional
  pattern: 'd{/}`m',
  // you can provide your own blocks definitions, default blocks for date mask are:
  blocks: {
    d: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2,
    },
    m: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2,
    },
  },
  // define date -> str convertion
  format(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;

    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;
    return [day, month].join('/');
  },
  // define str -> date convertion
  parse(str) {
    const yearMonthDay = str.split('/').map(Number);
    const date = new Date(2020, yearMonthDay[1] - 1, yearMonthDay[0]);
    return date;
  },

  // optional interval options
  min: new Date(1900, 0, 1), // defaults to `1900-01-01`
  max: new Date(2300, 0, 1), // defaults to `9999-01-01`

  // also Pattern options can be set
  lazy: false,

  // and other common options
  overwrite: true, // defaults to `false`
});

const phoneMask = (element) => IMask(element, {
  mask: [
    {
      mask: '00 00 00 00 00',
      startsWith: '0',
    },
    {
      mask: '+33 0 00 00 00 00',
      startsWith: '+33',
    },
  ],
});

export {
  birthDateMask,
  cciNumberMask,
  echeanceMask,
  ibanNumberMask,
  numberMask,
  oriasMask,
  phoneMask,
  siretMask,
};
